import { makeStyles } from "tss-react/mui"
import { blueGrey, lightBlue } from "../../../../mp-core/themes/palette"

export type RuleName =
  | "menu"
  | "menuList"
  | "menuItem"
  | "menuItemWithCheckbox"
  | "menuItemSelected"
  | "dropdownTitle"
  | "paper"
  | "collapsibleHeader"
  | "collapsibleMenuItem"
  | "collapsibleMinusIcon"
  | "collapsibleChip"
  | "collapsibleSelectedChip"
  | "collapsibleChevron"
  | "menuListItemSubheader"
  | "groupTitle"
  | "groupDivider"

export const useStyles = makeStyles<void, RuleName>()(
  ({ spacing, shadows, palette }) => ({
    menu: {},
    paper: {
      minWidth: "160px",
      borderRadius: "2px",
      boxShadow: shadows[6]
    },
    menuList: {
      paddingTop: spacing(1),
      paddingBottom: spacing(1)
    },
    menuItem: {
      padding: spacing(2, 4),
      minHeight: "auto",

      "&:hover, &:focus-visible": {
        backgroundColor: "#ECEEF1",
        color: palette.text.primary
      },

      "& .material-icons:not(.collapsibleMinusIcon)": {
        color: blueGrey[500]
      }
    },
    menuItemWithCheckbox: {
      padding: 0
    },
    menuItemSelected: {},
    dropdownTitle: {
      color: blueGrey[500],
      paddingLeft: spacing(2)
    },
    menuListItemSubheader: {
      fontSize: "0.5875rem",
      textTransform: "uppercase",
      lineHeight: "2rem"
    },
    groupTitle: {
      padding: spacing(1, 3, 2),
      fontSize: "0.6875rem",
      lineHeight: "0.875rem",
      fontWeight: 500,
      color: blueGrey[700],
      cursor: "default"
    },
    groupDivider: {
      borderColor: blueGrey[100]
    },
    collapsibleHeader: {
      padding: spacing(2),
      minHeight: "auto",
      cursor: "pointer",

      "&:hover, &:focus-visible": {
        backgroundColor: "#ECEEF1"
      }
    },
    collapsibleMenuItem: {
      paddingLeft: spacing(6)
    },
    collapsibleMinusIcon: {
      color: `${blueGrey[100]} !important`,
      paddingLeft: spacing(2)
    },
    collapsibleChip: {
      fontWeight: 600,
      backgroundColor: blueGrey[100],
      color: blueGrey[700],
      paddingLeft: spacing(0),
      paddingRight: spacing(0),
      minWidth: "fit-content"
    },
    collapsibleSelectedChip: {
      backgroundColor: lightBlue[600],
      color: palette.common.white
    },
    collapsibleChevron: {
      fontSize: "0.875rem",
      color: blueGrey[500]
    }
  })
)
